(() => {
  /** Validate Shopify-rendered DOM data before sending it to analytics. */
  function readProduct(link) {
    const { productId, productName, productHandle, productUrl } = link.dataset;
    if (
      typeof productId !== "string" ||
      !/^[1-9]\d{0,19}$/.test(productId) ||
      typeof productName !== "string" ||
      !productName.trim() ||
      productName.length > 1000 ||
      typeof productHandle !== "string" ||
      !/^[a-z0-9][a-z0-9-]{0,254}$/.test(productHandle) ||
      typeof productUrl !== "string"
    )
      return null;
    const url = new URL(productUrl, window.location.origin);
    const destination = new URL(link.href, window.location.origin);
    if (
      url.origin !== window.location.origin ||
      url.pathname !== `/products/${productHandle}` ||
      destination.origin !== window.location.origin ||
      destination.searchParams.get("product") !== productHandle
    )
      return null;
    return {
      product_id: productId,
      product_name: productName.slice(0, 100),
      product_handle: productHandle,
      product_url: url.href,
      link_url: destination.href,
      link_text: link.textContent.trim().slice(0, 100),
      link_location: "product_advice",
      items: [{ item_id: productId, item_name: productName.slice(0, 100) }],
    };
  }

  // Use the GA4 destinations loaded by Shopify's Google integration.
  // Do not configure another tag or generate a second page_view.
  function analyticsDestinations() {
    const ids = new Set();
    for (const script of document.querySelectorAll("script[src]")) {
      const url = new URL(script.src, window.location.origin);
      const id = url.searchParams.get("id");
      if (
        url.hostname === "www.googletagmanager.com" &&
        url.pathname === "/gtag/js" &&
        typeof id === "string" &&
        /^G-[A-Z0-9]+$/.test(id)
      )
        ids.add(id);
    }
    return [...ids];
  }

  function trackAdvice(event) {
    const link = event.target.closest?.("a[data-product-advice]");
    if (!link || event.defaultPrevented) return;
    let resume;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== "function")
        return;
      const product = readProduct(link);
      const destinations = analyticsDestinations();
      if (!product || !destinations.length) return;

      const sameTab =
        event.type === "click" &&
        event.button === 0 &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey &&
        !event.altKey &&
        (!link.target || link.target === "_self");
      let timer;
      let resumed = false;
      resume = () => {
        if (!sameTab || resumed) return;
        resumed = true;
        window.clearTimeout(timer);
        window.location.assign(link.href);
      };
      if (sameTab) {
        event.preventDefault();
        // Tracking must never strand a visitor when a tag is blocked or slow.
        timer = window.setTimeout(resume, 350);
      }
      window.gtag("event", "product_advice_click", {
        ...product,
        send_to: destinations,
        event_callback: resume,
        event_timeout: 300,
      });
    } catch {
      resume?.();
    }
  }

  document.addEventListener("click", trackAdvice);
  document.addEventListener("auxclick", (event) => {
    if (event.button === 1) trackAdvice(event);
  });
})();
